<app-back-button></app-back-button>
<div class="contents">
  <!-- ════ PAGE HEADER ════ -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Registos do Sistema</h1>
      <p class="page-header-sub">Veja e acompanhe os registos de atividade e auditoria da plataforma</p>
    </div>

    <div class="page-header-actions" *ngIf="pagination?.totalRecords !== undefined">
      <div class="header-stat-pill">
        <i class="fas fa-list-check text-primary"></i>
        <span>Total: <strong>{{ pagination.totalRecords }}</strong></span>
      </div>
    </div>
  </div>

  <div class="flex align-items-center justify-content-between mb-3">
    <app-search-bar [filters]="filters" [showPrimaryBtn]="false"
      (formValueChange)="handleFormValueChange($event)"></app-search-bar>
  </div>

  <div class="row mt-3">
    <ng-container *ngIf="pagination?.data?.length; else noGrupos">
      <app-table [pagination]="pagination" [columns]="columns" [actions]="actions" (pageChange)="onPageChange($event)"
        (rowClick)="getDetalhe($event)">
      </app-table>
    </ng-container>

    <ng-template #noGrupos>
      <div class="no-data">
        <app-data-void titulo="Nenhum registo encontrado" descricao="Tente novamente mais tarde.">
        </app-data-void>
      </div>
    </ng-template>
  </div>
</div>

<p-dialog [(visible)]="showDetalhe" [modal]="true" [style]="{ width: '52rem', maxWidth: '95vw' }" appendTo="body"
  [header]="'Registo de Auditoria'" [draggable]="false" [resizable]="false">
  <div class="log-detail-modal">
    <!-- Log Status Hero -->
    <div class="log-hero-banner" [class.success]="formLog.get('sucesso')?.value === 'Sucesso'"
      [class.error]="formLog.get('sucesso')?.value !== 'Sucesso'">
      <div class="log-hero-icon">
        <i class="fas fa-circle-check" *ngIf="formLog.get('sucesso')?.value === 'Sucesso'"></i>
        <i class="fas fa-circle-xmark" *ngIf="formLog.get('sucesso')?.value !== 'Sucesso'"></i>
      </div>
      <div class="log-hero-info">
        <div class="log-status-badge">
          {{ formLog.get('sucesso')?.value || 'Concluído' }}
        </div>
        <h3 class="log-action-title">{{ formLog.get('acao')?.value || 'Operação no Sistema' }}</h3>
      </div>
      <div class="log-hero-date">
        <i class="far fa-clock"></i>
        <span>{{ formLog.get('dataFormata')?.value || '—' }}</span>
      </div>
    </div>

    <!-- User & Metadata Info Grid -->
    <div class="log-meta-grid">
      <div class="log-meta-card">
        <div class="meta-icon user">
          <i class="fas fa-user-shield"></i>
        </div>
        <div class="meta-text">
          <span class="meta-label">Operador Responsável</span>
          <strong class="meta-value">{{ formLog.get('nome')?.value || 'Sistema / Anónimo' }}</strong>
          <span class="meta-sub">{{ formLog.get('email')?.value || 'Sem email associado' }}</span>
        </div>
      </div>

      <div class="log-meta-card">
        <div class="meta-icon event">
          <i class="fas fa-bolt"></i>
        </div>
        <div class="meta-text">
          <span class="meta-label">Evento Disparado</span>
          <strong class="meta-value">{{ formLog.get('acao')?.value || 'N/A' }}</strong>
          <span class="meta-sub">Execução registada com sucesso</span>
        </div>
      </div>
    </div>

    <!-- Payload JSON Card -->
    <div class="log-payload-card">
      <div class="payload-header">
        <div class="payload-title">
          <i class="fas fa-code text-primary"></i>
          <span>Dados do Payload (JSON)</span>
        </div>
        <button type="button" class="btn-copy-json" (click)="copiarJson()" title="Copiar JSON">
          <i class="far fa-copy"></i>
          <span>Copiar Dados</span>
        </button>
      </div>

      <div class="payload-body">
        <app-json-tree [data]="jsonLog"></app-json-tree>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center justify-content-end gap-2 w-full pt-2">
      <button type="button" class="btn-close-log" (click)="showDetalhe = false">
        <span>Fechar Detalhes</span>
      </button>
    </div>
  </ng-template>
</p-dialog>